/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import urlJoin from 'proper-url-join';

import { ApiPathPrefix } from '../../../ts/api';
import { getServerBaseUri } from './url';

/**
 * Generate the full URL to retrieve a specific page from the documentation
 * site.
 *
 * The prefix needs to take into account if we are executing as an MFE, because
 * in that case we need to make sure to directly access our server using the
 * MFE proxying prefix.
 *
 * @param path The path for the specific doc page
 */
export const generateDocsUrl = (path: string): string =>
  urlJoin(getServerBaseUri(), ApiPathPrefix.DOCS, path, {
    queryOptions: { encode: false }
  });
